/**
 * Testimonials from open source maintainers and contributors.
 */

export type RoleSegment = {
  text: string;
  url?: string;
};

export type Testimonial = {
  quote: string;
  username: string;
  /** Real name if known */
  name?: string;
  /** Role segments - each segment can optionally be a link */
  role: RoleSegment[];
  followers: number;
  commentUrl: string;
  profileUrl: string;
};

export const TESTIMONIALS: Testimonial[] = [
  {
    quote: "This is amazing! Thank you very much for your contribution 👍",
    username: "fmbenhassine",
    name: "Mahmoud Ben Hassine",
    role: [
      { text: "Project Lead of " },
      {
        text: "Spring\u00A0Batch",
        url: "https://spring.io/projects/spring-batch",
      },
      { text: " (" },
      { text: "Spring\u00A0Framework", url: "https://spring.io/" },
      { text: ")" },
    ],
    followers: 705,
    commentUrl:
      "https://github.com/spring-projects/spring-batch/pull/4880#issuecomment-2969830013",
    profileUrl: "https://github.com/fmbenhassine",
  },
  {
    quote:
      "I appreciate the feedback. We've factored in your feedback into the current implementation.",
    username: "eps1lon",
    name: "Sebastian Silbermann",
    role: [
      { text: "React", url: "https://react.dev/" },
      { text: " Core Team (Meta) & " },
      { text: "Material\u00A0UI", url: "https://mui.com/" },
      { text: " Maintainer" },
    ],
    followers: 1796,
    commentUrl:
      "https://github.com/mui/material-ui/pull/25309#discussion_r596679292",
    profileUrl: "https://github.com/eps1lon",
  },
  {
    quote: "LGTM. Thanks for this.",
    username: "alan-agius4",
    name: "Alan Agius",
    role: [
      { text: "Angular", url: "https://angular.dev/" },
      { text: " Core Team at " },
      { text: "Google", url: "https://google.com/" },
      { text: " (4.5M+\u00A0weekly\u00A0downloads)" },
    ],
    followers: 677,
    commentUrl:
      "https://github.com/angular/angular-cli/pull/23531#pullrequestreview-1034246567",
    profileUrl: "https://github.com/alan-agius4",
  },
  {
    quote: "Thanks @martinfrancois!",
    username: "gumadeiras",
    name: "Gustavo Madeira Santana",
    role: [
      { text: "Maintainer of " },
      { text: "OpenClaw", url: "https://openclaw.ai" },
      { text: " (386K+\u00A0stars on " },
      { text: "GitHub", url: "https://github.com/openclaw/openclaw" },
      { text: ")" },
    ],
    followers: 339,
    commentUrl:
      "https://github.com/openclaw/openclaw/pull/66877#issuecomment-4248370663",
    profileUrl: "https://github.com/gumadeiras",
  },
  {
    quote: "Clean read on all three points, thanks for catching them.",
    username: "jbaruch",
    name: "Baruch Sadogursky",
    role: [
      { text: "Java\u00A0Champion", url: "https://javachampions.org/" },
      { text: ", DevRel at " },
      { text: "Tessl", url: "https://tessl.io/" },
    ],
    followers: 471,
    commentUrl:
      "https://github.com/tesslio/good-oss-citizen/pull/22#issuecomment-4327650106",
    profileUrl: "https://github.com/jbaruch",
  },
  {
    quote: "Thank you very much",
    username: "lordofthejars",
    name: "Alex Soto",
    role: [
      { text: "Java\u00A0Champion", url: "https://javachampions.org/" },
      { text: ", Author, works at " },
      { text: "IBM", url: "https://www.ibm.com/" },
    ],
    followers: 604,
    commentUrl:
      "https://github.com/redhat-developer-demos/rhd-tutorial-common/pull/2#issuecomment-728899411",
    profileUrl: "https://github.com/lordofthejars",
  },
  {
    quote: "Awesome, great job!",
    username: "christian-bromann",
    name: "Christian Bromann",
    role: [
      { text: "Creator of " },
      { text: "WebdriverIO", url: "https://webdriver.io/" },
      { text: " (2.3M+\u00A0weekly\u00A0downloads)" },
    ],
    followers: 1463,
    commentUrl:
      "https://github.com/saucelabs/node-saucelabs/pull/97#issuecomment-709239161",
    profileUrl: "https://github.com/christian-bromann",
  },
  {
    quote: "thanks!",
    username: "bradzacher",
    name: "Brad Zacher",
    role: [
      { text: "Lead Maintainer of " },
      { text: "typescript-eslint", url: "https://typescript-eslint.io/" },
      { text: " (116M+\u00A0weekly\u00A0downloads)" },
    ],
    followers: 527,
    commentUrl:
      "https://github.com/typescript-eslint/typescript-eslint/pull/2758#pullrequestreview-532660707",
    profileUrl: "https://github.com/bradzacher",
  },
  {
    quote: "Thank you for the contribution.",
    username: "bcoe",
    name: "Benjamin E. Coe",
    role: [
      { text: "Maintainer of " },
      { text: "yargs", url: "https://yargs.js.org/" },
      { text: " & " },
      { text: "Istanbul", url: "https://istanbul.js.org/" },
      { text: " (210M+\u00A0weekly\u00A0downloads)" },
    ],
    followers: 1722,
    commentUrl:
      "https://github.com/conventional-changelog/standard-version/pull/689#issuecomment-736706042",
    profileUrl: "https://github.com/bcoe",
  },
  {
    quote: "Done, thanks again :)",
    username: "balloob",
    name: "Paulus Schoutsen",
    role: [
      { text: "Founder of " },
      { text: "Home\u00A0Assistant", url: "https://www.home-assistant.io/" },
      { text: " (2M+\u00A0installations)" },
    ],
    followers: 2957,
    commentUrl:
      "https://github.com/home-assistant/core/pull/5908#issuecomment-287498983",
    profileUrl: "https://github.com/balloob",
  },
  {
    quote: "Thanks for the test case.",
    username: "oliviertassinari",
    name: "Olivier Tassinari",
    role: [
      { text: "Co-founder & CEO of " },
      { text: "MUI", url: "https://mui.com/" },
      {
        text: " (Material\u00A0UI for React, 8.7M+\u00A0weekly\u00A0downloads)",
      },
    ],
    followers: 3339,
    commentUrl:
      "https://github.com/mui/material-ui/pull/25309#pullrequestreview-611588082",
    profileUrl: "https://github.com/oliviertassinari",
  },
  {
    quote:
      "Good catch, will check this out locally and get this merged. Thank you so much for your help!",
    username: "amruthpillai",
    name: "Amruth Pillai",
    role: [
      { text: "Creator of " },
      { text: "Reactive Resume", url: "https://rxresu.me/" },
      { text: " (40K+\u00A0stars on " },
      {
        text: "GitHub",
        url: "https://github.com/amruthpillai/reactive-resume",
      },
      { text: ")" },
    ],
    followers: 1964,
    commentUrl:
      "https://github.com/amruthpillai/reactive-resume/pull/2770#issuecomment-3999777551",
    profileUrl: "https://github.com/amruthpillai",
  },
  {
    quote:
      "thanks for including our review :-) type hints are always helpful 👍",
    username: "thrau",
    name: "Dr. Thomas Rausch",
    role: [
      { text: "Co-founder & Principal Engineer at " },
      { text: "LocalStack", url: "https://localstack.cloud/" },
    ],
    followers: 278,
    commentUrl:
      "https://github.com/localstack/localstack/pull/12053#pullrequestreview-2522554922",
    profileUrl: "https://github.com/thrau",
  },
  {
    quote: "lgtm and great commit history management!",
    username: "eternal-flame-AD",
    name: "Yumechi",
    role: [
      { text: "Gotify", url: "https://gotify.net/" },
      { text: " Contributor" },
    ],
    followers: 146,
    commentUrl:
      "https://github.com/gotify/server/pull/815#pullrequestreview-3049751520",
    profileUrl: "https://github.com/eternal-flame-AD",
  },
  {
    quote:
      "Thanks for the quick turn around. Thanks for contributing to InfluxDB and making the docs better 😄",
    username: "mgattozzi",
    name: "Michael Gattozzi",
    role: [
      { text: "Staff Engineer at " },
      { text: "InfluxDB", url: "https://www.influxdata.com/" },
      { text: " (1.1B+\u00A0Docker\u00A0pulls)" },
    ],
    followers: 492,
    commentUrl:
      "https://github.com/influxdata/influxdb/pull/24577#pullrequestreview-1824585858",
    profileUrl: "https://github.com/mgattozzi",
  },
  {
    quote: "Thanks, all!",
    username: "jgm",
    name: "John MacFarlane",
    role: [
      { text: "Creator of " },
      { text: "Pandoc", url: "https://pandoc.org/" },
      { text: " (3M+\u00A0Docker\u00A0pulls)" },
    ],
    followers: 3327,
    commentUrl:
      "https://github.com/jgm/pandoc/pull/5589#issuecomment-511161580",
    profileUrl: "https://github.com/jgm",
  },
  {
    quote: "Thanks, @martinfrancois 👍",
    username: "frenck",
    name: "Franck Nijhof",
    role: [
      { text: "Core Team Member of " },
      { text: "Home\u00A0Assistant", url: "https://www.home-assistant.io/" },
    ],
    followers: 4970,
    commentUrl:
      "https://github.com/home-assistant/home-assistant.io/pull/24667#pullrequestreview-1185712287",
    profileUrl: "https://github.com/frenck",
  },
  {
    quote: "Thanks very much for the documentation improvements!",
    username: "bigdaz",
    name: "Daz DeBoer",
    role: [
      { text: "Composite Builds Team Lead at " },
      { text: "Gradle", url: "https://gradle.com/" },
    ],
    followers: 97,
    commentUrl:
      "https://github.com/gradle/actions/pull/41#issuecomment-1942823590",
    profileUrl: "https://github.com/bigdaz",
  },
  {
    quote: "Thanks for the explanation!",
    username: "jmattheis",
    name: "Jannis Mattheis",
    role: [
      { text: "Creator of " },
      { text: "Gotify", url: "https://gotify.net/" },
      { text: " (45M+\u00A0Docker\u00A0pulls)" },
    ],
    followers: 397,
    commentUrl:
      "https://github.com/gotify/server/pull/815#discussion_r2232792913",
    profileUrl: "https://github.com/jmattheis",
  },
  {
    quote: "Thanks!",
    username: "Koenkk",
    name: "Koen Kanters",
    role: [
      { text: "Maintainer of " },
      {
        text: "zigbee-herdsman-converters",
        url: "https://github.com/Koenkk/zigbee-herdsman-converters",
      },
    ],
    followers: 2599,
    commentUrl:
      "https://github.com/Koenkk/zigbee-herdsman-converters/pull/11911#issuecomment-4229351602",
    profileUrl: "https://github.com/Koenkk",
  },
  {
    quote: "thanks :)",
    username: "KazuCocoa",
    name: "Kazuaki Matsuo",
    role: [
      { text: "Maintainer of " },
      { text: "Appium", url: "https://appium.io/" },
      { text: " (1M+\u00A0weekly\u00A0downloads)" },
    ],
    followers: 625,
    commentUrl:
      "https://github.com/appium/appium/pull/14312#discussion_r422728379",
    profileUrl: "https://github.com/KazuCocoa",
  },
  {
    quote: "Thanks for hooking this up!",
    username: "mfix22",
    name: "Mike Fix",
    role: [
      { text: "Creator of " },
      { text: "carbon.sh", url: "https://carbon.now.sh/" },
    ],
    followers: 615,
    commentUrl:
      "https://github.com/carbon-app/carbon/pull/199#issuecomment-362939895",
    profileUrl: "https://github.com/mfix22",
  },
  {
    quote: "Thank you!",
    username: "paulmelnikow",
    name: "Paul Melnikow",
    role: [
      { text: "Maintainer of " },
      { text: "nock", url: "https://github.com/nock/nock" },
    ],
    followers: 291,
    commentUrl: "https://github.com/nock/nock/pull/1740#issuecomment-539102492",
    profileUrl: "https://github.com/paulmelnikow",
  },
  {
    quote: "Nice catch, LGTM, thank you!",
    username: "agners",
    name: "Stefan Agner",
    role: [
      { text: "Maintainer of " },
      { text: "Home\u00A0Assistant", url: "https://www.home-assistant.io/" },
      { text: " Supervisor" },
    ],
    followers: 219,
    commentUrl:
      "https://github.com/home-assistant/supervisor/pull/7000#pullrequestreview-4635571732",
    profileUrl: "https://github.com/agners",
  },
  {
    quote: "Awesome! Thanks for the contribution 👍",
    username: "jakedex",
    name: "Jake Dexheimer",
    role: [
      { text: "Co-creator of " },
      { text: "carbon.sh", url: "https://carbon.now.sh/" },
    ],
    followers: 95,
    commentUrl:
      "https://github.com/carbon-app/carbon/pull/199#issuecomment-370634560",
    profileUrl: "https://github.com/jakedex",
  },
  {
    quote: "This looks good to go!",
    username: "thecodrr",
    name: "Abdullah Atta",
    role: [
      { text: "CEO & Lead developer of " },
      { text: "Notesnook", url: "https://notesnook.com/" },
      { text: " (Streetwriters)" },
    ],
    followers: 376,
    commentUrl:
      "https://github.com/streetwriters/notesnook-importer/pull/83#issuecomment-1653113325",
    profileUrl: "https://github.com/thecodrr",
  },
  {
    quote: "Thank you!",
    username: "wopian",
    name: "James Harris",
    role: [
      { text: "Software Engineer at " },
      { text: "Expenti", url: "https://www.expenti.com/" },
      { text: ", contributor to " },
      { text: "Apollo-11", url: "https://github.com/chrislgarry/Apollo-11" },
    ],
    followers: 396,
    commentUrl:
      "https://web.archive.org/web/20230315113457/https://github.com/chrislgarry/Apollo-11/pull/891#issuecomment-1302610074",
    profileUrl: "https://github.com/wopian",
  },
  {
    quote: "Thanks for the double fixes here!",
    username: "timtebeek",
    name: "Tim te Beek",
    role: [
      { text: "Maintainer of " },
      { text: "OpenRewrite", url: "https://docs.openrewrite.org/" },
      { text: " (Moderne)" },
    ],
    followers: 284,
    commentUrl:
      "https://github.com/openrewrite/rewrite-static-analysis/pull/988#pullrequestreview-4950033607",
    profileUrl: "https://github.com/timtebeek",
  },
  {
    quote: "Thanks for looking into it and for your time!",
    username: "HarelM",
    name: "Harel M",
    role: [
      { text: "Maintainer of " },
      { text: "MapLibre GL JS", url: "https://maplibre.org/" },
    ],
    followers: 178,
    commentUrl:
      "https://github.com/maplibre/maplibre-gl-js/pull/8128#issuecomment-5230056587",
    profileUrl: "https://github.com/HarelM",
  },
  {
    quote: "Thanks @martinfrancois!",
    username: "Takhoffman",
    name: "Tak Hoffman",
    role: [
      { text: "Maintainer of " },
      { text: "OpenClaw", url: "https://openclaw.ai" },
      { text: " (386K+\u00A0stars on " },
      { text: "GitHub", url: "https://github.com/openclaw/openclaw" },
      { text: ")" },
    ],
    followers: 268,
    commentUrl:
      "https://github.com/openclaw/openclaw/pull/24775#issuecomment-3980315797",
    profileUrl: "https://github.com/Takhoffman",
  },
  {
    quote: "Thanks @martinfrancois",
    username: "MartinWitt",
    name: "Martin Wittlinger",
    role: [
      { text: "Maintainer of " },
      { text: "Spoon", url: "https://github.com/INRIA/spoon" },
      { text: " (" },
      { text: "Inria", url: "https://www.inria.fr/en" },
      { text: ")" },
    ],
    followers: 61,
    commentUrl:
      "https://github.com/INRIA/spoon/pull/6794#issuecomment-4984950754",
    profileUrl: "https://github.com/MartinWitt",
  },
  {
    quote: "Thanks for making these changes. The PR now looks good to me.",
    username: "stephan-herrmann",
    name: "Stephan Herrmann",
    role: [
      { text: "Committer of " },
      {
        text: "Eclipse JDT Core",
        url: "https://github.com/eclipse-jdt/eclipse.jdt.core",
      },
    ],
    followers: 16,
    commentUrl:
      "https://github.com/eclipse-jdt/eclipse.jdt.core/pull/5207#issuecomment-5233035104",
    profileUrl: "https://github.com/stephan-herrmann",
  },
  {
    quote: "Code looks good. [...] Thanks @martinfrancois !",
    username: "mpalat",
    name: "Manoj N Palat",
    role: [
      { text: "Committer of " },
      {
        text: "Eclipse JDT Core",
        url: "https://github.com/eclipse-jdt/eclipse.jdt.core",
      },
      { text: " (" },
      { text: "IBM", url: "https://www.ibm.com/" },
      { text: ")" },
    ],
    followers: 11,
    commentUrl:
      "https://github.com/eclipse-jdt/eclipse.jdt.core/pull/5194#pullrequestreview-4727305477",
    profileUrl: "https://github.com/mpalat",
  },
  {
    quote: "Thanks for this @martinfrancois",
    username: "rossmechanic",
    name: "Ross Mechanic",
    role: [
      { text: "Co-founder & CEO of " },
      { text: "Maybern", url: "https://www.maybern.com/about-us" },
      { text: ", maintainer of " },
      {
        text: "django-simple-history",
        url: "https://github.com/django-commons/django-simple-history",
      },
    ],
    followers: 12,
    commentUrl:
      "https://github.com/django-commons/django-simple-history/pull/713#pullrequestreview-494695643",
    profileUrl: "https://github.com/rossmechanic",
  },
  {
    quote:
      "Looking good, thanks for taking the effort to add support for this.",
    username: "aequitas",
    name: "Johan Bloemberg",
    role: [
      { text: "DevOps Engineer, " },
      { text: "Home\u00A0Assistant", url: "https://www.home-assistant.io/" },
      { text: " Contributor" },
    ],
    followers: 29,
    commentUrl:
      "https://github.com/home-assistant/core/pull/6521#issuecomment-286064557",
    profileUrl: "https://github.com/aequitas",
  },
  {
    quote: "@martinfrancois Thank you very much for the correction.",
    username: "m-abs",
    name: "Morten Sjøgren",
    role: [
      { text: "Developer at " },
      { text: "Nota", url: "https://nota.dk/" },
      { text: " (Danish library for people with print disabilities)" },
    ],
    followers: 26,
    commentUrl:
      "https://github.com/Notalib/nativescript-accessibility-ext/pull/47#issuecomment-626220379",
    profileUrl: "https://github.com/m-abs",
  },
  {
    quote: "@martinfrancois, Thank you for this PR!",
    username: "Fatme",
    role: [{ text: "NativeScript maintainer" }],
    followers: 14,
    commentUrl:
      "https://github.com/NativeScript/nativescript-cli/pull/4565#issuecomment-487864160",
    profileUrl: "https://github.com/Fatme",
  },
  {
    quote: "Thank you for your contributions",
    username: "BeeHiveSafety",
    name: "BeeHive",
    role: [
      { text: "Security automation tooling by " },
      { text: "BeeHiveSafety" },
      { text: " (" },
      {
        text: "Cloudflare WAF to AbuseIPDB",
        url: "https://github.com/BeeHiveSafety/CloudflareToAbuseIPDB",
      },
      { text: ")" },
    ],
    followers: 33,
    commentUrl:
      "https://github.com/BeeHiveSafety/CloudflareToAbuseIPDB/pull/3#issuecomment-1793802600",
    profileUrl: "https://github.com/BeeHiveSafety",
  },
  {
    quote: "Thanks for the contribution! Happy to merge and republish",
    username: "sam-silv",
    name: "Sam Silverman",
    role: [
      { text: "Creator of " },
      { text: "Histoslider", url: "https://github.com/sam-silv/histoslider" },
    ],
    followers: 35,
    commentUrl:
      "https://github.com/sam-silv/histoslider/pull/105#issuecomment-614022674",
    profileUrl: "https://github.com/sam-silv",
  },
  {
    quote: "Thank you @martinfrancois!",
    username: "Blargian",
    name: "Shaun Struwig",
    role: [
      { text: "Team member at " },
      { text: "ClickHouse", url: "https://clickhouse.com/" },
      { text: " (" },
      {
        text: "clickhouse-docs",
        url: "https://github.com/ClickHouse/clickhouse-docs",
      },
      { text: ")" },
    ],
    followers: 25,
    commentUrl:
      "https://github.com/ClickHouse/clickhouse-docs/pull/5658#issuecomment-4025154340",
    profileUrl: "https://github.com/Blargian",
  },
  {
    quote: "Thanks for the contribution!",
    username: "mshabarov",
    name: "Mikhail Shabarov",
    role: [
      { text: "Product Owner in the " },
      { text: "Vaadin\u00A0Flow", url: "https://github.com/vaadin/flow" },
      { text: " Team" },
    ],
    followers: 6,
    commentUrl:
      "https://github.com/vaadin/flow/pull/24220#issuecomment-4368777786",
    profileUrl: "https://github.com/mshabarov",
  },
  {
    quote: "makes sense @martinfrancois thanks",
    username: "marandaneto",
    name: "Manoel Aranda Neto",
    role: [
      { text: "Client Libraries at " },
      { text: "PostHog", url: "https://posthog.com/" },
    ],
    followers: 220,
    commentUrl:
      "https://github.com/PostHog/posthog-js/pull/4603#issuecomment-5384716312",
    profileUrl: "https://github.com/marandaneto",
  },
  {
    quote: "Thank you for the improvement. The change looks really good.",
    username: "wanasit",
    name: "Wanasit Tanakitrungruang",
    role: [
      { text: "Author and maintainer of " },
      { text: "Chrono", url: "https://github.com/wanasit/chrono" },
      { text: " (2.4M+\u00A0weekly\u00A0downloads)" },
    ],
    followers: 182,
    commentUrl:
      "https://github.com/wanasit/chrono/pull/654#issuecomment-5843880599",
    profileUrl: "https://github.com/wanasit",
  },
];
